export default __webpack_public_path__ + "static/HealthFirst-1a15f382daa52761462431c0759d361f.svg";